import React from 'react';
import { Phone } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import QuoteForm from '../components/QuoteForm';
import FloatingQuoteButton from '../components/FloatingQuoteButton';

const RequestQuotePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Spacer for fixed navbar */}
      <div className="pt-32 sm:pt-36" />

      {/* Phone CTA */}
      <div className="text-center py-8 bg-gray-50">
        <p className="text-gray-600 mb-2">Prefer to talk? Call or text us directly</p>
        <a
          href="tel:6316608164"
          className="inline-flex items-center gap-2 text-blue-600 font-bold text-2xl hover:text-blue-700 transition-colors"
          data-testid="quote-page-phone"
        >
          <Phone className="w-6 h-6" />
          (631) 660-8164
        </a>
      </div>

      {/* Quote Form */}
      <QuoteForm />

      <Footer />
    </div>
  );
};

export default RequestQuotePage;
